import gql from 'graphql-tag';

// Installation-scoped on the server via the x-installation-id header (no arg).
export const listParkingOperationsBays = gql`
    query parklioOperationsBaysForInstallation {
        parklioOperationsBaysForInstallation {
            id
            label
            zone
            status
            reachability
            batteryPercent
            batteryLow
            position
            carPresent
            overstaying
            currentBooking {
                bookingId
                guestName
                startDay
                endDay
                plate
            }
        }
    }
`;

export const listBayTimeline = gql`
    query parklioBayTimeline($startDay: String!, $endDay: String!) {
        parklioBayTimeline(startDay: $startDay, endDay: $endDay) {
            bayId
            label
            bookings {
                bookingId
                guestName
                guestRoom
                plate
                lo
                hi
                status
            }
        }
    }
`;

export const listParkingOperationsLog = gql`
    query parklioBayActionLog($limit: Int, $offset: Int, $action: String, $from: String, $to: String, $order: String) {
        parklioBayActionLog(limit: $limit, offset: $offset, action: $action, from: $from, to: $to, order: $order) {
            id
            parkingBayId
            action
            outcome
            reason
            performedByEmail
            createdAt
        }
    }
`;
